import { MergeTags } from "@/components/Editor";

type TagKeys = "firstName" | "lastName" | "amount" | "email";

export const Tags: Record<TagKeys, MergeTags> = {
  firstName: {
    raw: "{{firstName}}",
    description: "Donor's first name",
  },
  lastName: {
    raw: "{{lastName}}",
    description: "Donor's last name",
  },
  email: {
    raw: "{{email}}",
    description: "Donor's email",
  },
  amount: {
    raw: "{{amount}}",
    description: "Donation amount",
  },
};

export function detectInvalidMergeTags(
  message: string,
  acceptedTags: MergeTags[] | undefined
): string[] {
  const regex = /\{\{(\w+)\}\}/g;
  const invalidTags: string[] = [];
  let match;

  while ((match = regex.exec(message)) !== null) {
    const rawTag = match[0]; // The entire raw merge tag, including curly braces
    const tagContent = match[1]; // The content inside the curly braces (e.g., "firstName")

    if (!acceptedTags?.some((tag) => tag.raw === rawTag)) {
      invalidTags.push(tagContent);
    }
  }

  return invalidTags;
}
